import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import { wrapDisplayName } from 'recompose';
import { connect } from 'react-redux';
import { Alert } from '@deerplusofficial/pos-components';
import { toCurrency, createCancelToken } from '@deerplusofficial/pos-helper';
import { withClient } from '@deerplusofficial/pos-hoc';
import actions from '../../actions';

const { reset: resetReceipt } = actions.receipt;
const { reset: resetPayment } = actions.payment;

export default () => Component =>
  fp.compose(
    withClient(),
    connect(
      null,
      { resetReceipt, resetPayment }
    )
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithCancelOrder');

      componentWillUnmount() {
        !_.isUndefined(this.cancelCancelOrder) && this.cancelCancelOrder();
      }

      onOrderCancelPrompt = async ({
        orderId,
        orderNumber,
        totalPrice,
        refetch = _.identity,
      }) => {
        const {
          client: { onError },
        } = this.props;

        const { value: payload } = await Alert.fire({
          title: `您正在取消訂單 ${orderNumber}\n結帳總金額：${toCurrency(
            totalPrice
          )}`,
          confirmButtonText: '送出',
          cancelButtonText: '放棄操作',
          showCancelButton: true,
          showLoaderOnConfirm: true,
          input: 'textarea',
          inputPlaceholder: '請填寫訂單取消原因',
          inputValidator: value => !value && '取消原因是必填項目',
          preConfirm: async note => {
            try {
              return await this.cancelOrder({ orderId, note });
            } catch (error) {
              return error;
            }
          },
        });

        if (!payload) return;

        _.size(payload.data)
          ? Alert({
              title: '訂單取消成功',
              type: 'success',
              preConfirm: refetch,
            })
          : onError(payload);
      };

      onOrderCancel = async ({ orderId, note }) => {
        const {
          client: { onError },
        } = this.props;

        try {
          await this.cancelOrder({ orderId, note });
        } catch (e) {
          onError(e);
        }
      };

      cancelOrder = async ({ orderId, note }) => {
        const {
          resetReceipt,
          resetPayment,
          client: { POSApi },
        } = this.props;

        const payload = await POSApi.post(
          `/orders/${orderId}/cancel`,
          { note },
          { cancelToken: createCancelToken(this.cancelCancelOrder) }
        );

        resetReceipt();
        resetPayment();

        return payload;
      };

      render() {
        return (
          <Component
            onOrderCancelPrompt={this.onOrderCancelPrompt}
            onOrderCancel={this.onOrderCancel}
            {...this.props}
          />
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Mutations/withCancelOrder.js